import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '@vebox/etui-colors';
import Spinner from '../Spinner/Spinner.js';
import { S as SpinnerSize } from '../utils-fabc7ae7.js';

const SpinnerWrapper = styled(Div)`
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  z-index: 5;
  background: rgba(255, 255, 255, 0.5);
`;

const TableLoader = ({
  height = 100
}) => /*#__PURE__*/createElement(SpinnerWrapper, {
  style: {
    height
  }
}, /*#__PURE__*/createElement(Spinner, {
  size: SpinnerSize.small
}));

export default TableLoader;
